export const avatar = {
  cropTitle: "画像を切り抜き",
  cropImageAlt: "切り抜き対象の画像",
  upload: "アップロード",
  uploading: "アップロード中…",
  cancel: "キャンセル",
  uploadFailed: "アップロードに失敗しました",
  uploadSuccess: "プロフィール画像の申請が完了しました",
  uploadSuccessDescription:
    "不適切な表現が含まれる場合、否認となる可能性がございます。",
  underReview: "審査中",
  loadErrorTitle: "画像を読み込めません",
  loadErrorMessage:
    "この形式の画像には対応していません。\nJPEG または PNG の画像を選んでください。",
  delete: "写真を削除",
  deleteConfirmTitle: "この写真を削除しますか？",
  deleteConfirmDescription: "削除した写真は元に戻せません",
  deleteConfirm: "削除",
  deleteSuccess: "写真を削除しました",
  deleteFailed: "削除に失敗しました",
  iconBadge: "アイコン",
  subPhotosLabel: "サブ写真",
  dragHint: "長押ししてドラッグでアイコンと入れ替え",
  dropToSetIcon: "ここで離すとアイコンに設定",
  setIconSuccess: "アイコンを変更しました",
  setIconFailed: "アイコンを変更できませんでした",
  setIconNotApproved: "審査中・非公開の写真はアイコンにできません",
} as const;
